import { useEffect, useState } from "react";
import { Ticket, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export const CouponsTab = () => {
  const [coupons, setCoupons] = useState(null);

  useEffect(() => {
    api.get("/account/coupons").then((r) => setCoupons(r.data)).catch(() => setCoupons([]));
  }, []);

  const copy = (code) => {
    navigator.clipboard?.writeText(code);
    toast.success(`${code} copied`);
  };

  if (coupons === null) return <div className="h-32 bg-[#141414] animate-pulse border border-white/5" />;

  if (coupons.length === 0) {
    return (
      <div className="border border-white/5 py-16 text-center" data-testid="coupons-empty">
        <p className="font-serif text-2xl text-zinc-400 italic">No privileges issued yet</p>
        <p className="mt-3 text-sm text-zinc-600">Coupons granted to you will appear here.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="coupons-list">
      {coupons.map((c) => {
        const expired = c.expires_at && new Date(c.expires_at) < new Date();
        const inactive = c.used || expired;
        return (
          <div
            key={c.id}
            data-testid={`coupon-${c.code}`}
            className={`relative border p-6 md:p-8 overflow-hidden ${
              inactive ? "border-white/5 opacity-50" : "border-maroon/60 bg-gradient-to-br from-maroon-deep/40 to-[#141414]"
            }`}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-[10px] tracking-[0.35em] uppercase text-gold flex items-center gap-2">
                  <Ticket size={12} /> {c.discount_pct}% Privilege
                </p>
                <p className="mt-3 font-serif text-2xl text-[#F5F5F5]">{c.title}</p>
                <p className="mt-2 text-sm text-zinc-400">{c.description}</p>
              </div>
              <button
                data-testid={`coupon-copy-${c.code}`}
                onClick={() => copy(c.code)}
                disabled={inactive}
                className="flex items-center gap-2 border border-gold/40 px-4 py-2 text-xs tracking-[0.25em] text-gold hover:bg-gold hover:text-black transition-colors duration-300 disabled:pointer-events-none"
              >
                {c.code} <Copy size={12} />
              </button>
            </div>
            <p className="mt-6 text-[10px] tracking-[0.25em] uppercase text-zinc-600">
              {c.used ? "Redeemed" : expired ? "Expired" : `Valid until ${new Date(c.expires_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}`}
            </p>
          </div>
        );
      })}
    </div>
  );
};
